<template>
    <div>
        <div>
            <legend><strong>Hasil Penilaian Teknis</strong> </legend>
            <legend>Surat Permohonan</legend>
              <b-row>
                <b-col md="6">
                  <b-form-group label="Pejabat Penandatangan Surat *" label-for="form">
                    <b-form-input disabled v-validate="'required'" name="Pejabat Penandatangan Surat" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.Pejabat Penandatangan Surat'),
                    }" v-model="dataPermohonan.jenis_surat_penerbitan" type="text" />
                    <span class="text-danger" v-if="errors.has('form-1.Pejabat Penandatangan Surat')">
                      {{ errors.first("form-1.Pejabat Penandatangan Surat") }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Nomor Surat *" label-for="form">
                    <b-form-input disabled v-validate="'required'" name="Nomor Surat" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.Nomor Surat'),
                    }" v-model="dataPermohonan.nomor_surat_penerbitan" type="text" />
                    <span class="text-danger" v-if="errors.has('form-1.Nomor Surat')">
                      {{ errors.first("form-1.Nomor Surat") }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Tanggal Surat *" label-for="form">
                    <input disabled type="date" v-validate="'required'" name="Tanggal Surat" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.Tanggal Surat'),
                    }" v-model="dataPermohonan.tanggal_surat_penerbitan" />
                    <span class="text-danger" v-if="errors.has('form-1.Tanggal Surat')">
                      {{ errors.first("form-1.Tanggal Surat") }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Perihal Surat *" label-for="form">
                    <b-form-input disabled v-validate="'required'" name="Perihal Surat" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.Perihal Surat'),
                    }" v-model="dataPermohonan.perihal_surat_penerbitan" type="text" />
                    <span class="text-danger" v-if="errors.has('form-1.Perihal Surat')">
                      {{ errors.first("form-1.Perihal Surat") }}
                    </span>
                  </b-form-group>
                </b-col>


              </b-row>

              <legend class="mt-3">Detail Permohonan</legend>
            <b-row>
                <div class="col-md-6">
                    <b-form-group label="Provinsi *">
                        <v-select
                            
                            id="default-select"
                            v-model="dataPermohonan.provinsi"
                            :reduce="provinsi => provinsi.nama_provinsi"
                            label="nama_provinsi"
                            :options="dataProvinsi"
                            v-validate="'required'" name="Provinsi"
                            :class="{ 'is-invalid': errors.has('form-1.Provinsi') }"
                            @input="getKabupaten(dataPermohonan.provinsi)"
                            disabled
                        />
                        <span class="text-danger" v-if="errors.has('form-1.Provinsi')">
                            {{ errors.first('form-1.Provinsi') }}
                        </span>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group label="Kabupaten *">
                        <v-select
                            
                            id="default-select"
                            v-model="dataPermohonan.kabupaten"
                            :reduce="kabupaten => kabupaten.nama_kabupaten"
                            label="nama_kabupaten"
                            :options="dataKabupaten"
                            v-validate="'required'" name="Kabupaten"
                            :class="{ 'is-invalid': errors.has('form-1.Kabupaten') }"
                            @input="getKecamatan(dataPermohonan.kabupaten)"
                            disabled
                        />
                        <span class="text-danger" v-if="errors.has('form-1.Kabupaten')">
                            {{ errors.first('form-1.Kabupaten') }}
                        </span>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group label="Kecamatan *">
                        <v-select
                            
                            id="default-select"
                            v-model="dataPermohonan.kecamatan"
                            :reduce="kecamatan => kecamatan.nama_kecamatan"
                            label="nama_kecamatan"
                            :options="dataKecamatan"
                            v-validate="'required'" name="Kecamatan"
                            :class="{ 'is-invalid': errors.has('form-1.Kecamatan') }"
                            disabled
                        />
                        <span class="text-danger" v-if="errors.has('form-1.Kecamatan')">
                            {{ errors.first('form-1.Kecamatan') }}
                        </span>
                    </b-form-group>
                </div>
                <b-col md="6">
                    <b-form-group label="Jenis Permohonan: *">
                        <v-select
                        id="default-select"
                        v-model="dataPermohonan.jenis_permohonan"
                        :reduce="jenis => jenis.nama"
                        label="nama"
                        :options="dataJenisPermohonan"
                        v-validate="'required'" name="Jenis Permohonan"
                        :class="{ 'is-invalid': errors.has('form-3.Jenis Permohonan') }"
                        disabled
                    />
                        <span class="text-danger" v-if="errors.has('form-3.Jenis Permohonan')">
                            {{ errors.first('form-3.Jenis Permohonan') }}
                        </span>
                    </b-form-group>
                </b-col>
                <!-- <b-col md="6">
                    <b-form-group label="Klasifikasi Pemohon: *">
                        <v-select
                        id="default-select"
                        v-model="dataPermohonan.klasifikasi_pemohon"
                        :reduce="klasifikasi => klasifikasi.nama"
                        label="nama"
                        :options="dataKlasifikasi"
                        v-validate="'required'" name="Klasifikasi Pemohon"
                        :class="{ 'is-invalid': errors.has('form-3.Klasifikasi Pemohon') }"
                        disabled
                    />
                        <span class="text-danger" v-if="errors.has('form-3.Klasifikasi Pemohon')">
                            {{ errors.first('form-3.Klasifikasi Pemohon') }}
                        </span>
                    </b-form-group>
                </b-col> -->
                <b-col md="6">
                    <b-form-group label="Nama Perairan *">
                    <b-form-input v-validate="'required'" name="Nama Perairan"
                        :class="{ 'form-control': true, 'is-invalid': errors.has('form-1.Nama Perairan') }" v-model="dataPermohonan.nama_perairan" type="text" disabled/>
                        <span class="text-danger" v-if="errors.has('form-1.Nama Perairan')">
                            {{ errors.first('form-1.Nama Perairan') }}
                        </span>
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label="Garis Pantai *">
                    <b-form-input v-validate="'required'" name="Garis Pantai"
                        :class="{ 'form-control': true, 'is-invalid': errors.has('form-1.Garis Pantai') }" v-model="dataPermohonan.garis_pantai" type="text" disabled/>
                        <span class="text-danger" v-if="errors.has('form-1.Garis Pantai')">
                            {{ errors.first('form-1.Garis Pantai') }}
                        </span>
                    </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Jenis Permohonan: *">
                    <v-select
                      disabled
                      id="default-select"
                      v-model="dataPermohonan.jenis_pnbp"
                      :options="[
                        'Area',
                        'Kabel Bawah Laut',
                        'Pipa Air Bersih / Air Baku',
                        'Pipa Selain Air Bersih / Air Baku',
                      ]"
                      v-validate="'required'"
                      name="Jenis Permohonan"
                      :class="{ 'is-invalid': errors.has('form-1.Jenis Permohonan') }"
                      @input="resetPNBP"
                    />
                    <span
                      class="text-danger"
                      v-if="errors.has('form-1.Jenis Permohonan')"
                    >
                      {{ errors.first("form-1.Jenis Permohonan") }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col md="6" v-if="dataPermohonan.jenis_pnbp == 'Area'">
                  <b-form-group label="Luas (ha) *">
                    <b-form-input
                    disabled
                      min="0"
                      step=".01"
                      type="number"
                      name="Luas"
                      :class="{
                        'form-control': true,
                        'is-invalid': errors.has('form-1.Luas'),
                      }"
                      v-model="dataPermohonan.luas"
                    />
                    <span class="text-danger" v-if="errors.has('form-1.Luas')">
                      {{ errors.first("form-1.Luas") }}
                    </span>
                  </b-form-group>
                </b-col>

                <b-col
                  md="6"
                  v-if="
                    dataPermohonan.jenis_pnbp == 'Kabel Bawah Laut' ||
                    dataPermohonan.jenis_pnbp == 'Pipa Air Bersih / Air Baku' ||
                    dataPermohonan.jenis_pnbp ==
                      'Pipa Selain Air Bersih / Air Baku'
                  "
                >
                  <b-form-group label="Panjang (di dalam Kws. Konservasi)(km)*">
                    <b-form-input
                    disabled
                      min="0"
                      step=".01"
                      type="number"
                      name="Panjang (di dalam Kws. Konservasi)(km)"
                      :class="{
                        'form-control': true,
                        'is-invalid': errors.has(
                          'form-1.Panjang (di dalam Kws. Konservasi)(km)'
                        ),
                      }"
                      v-model="dataPermohonan.panjang_konservasi"
                    />
                    <span
                      class="text-danger"
                      v-if="errors.has('form-1.Panjang (di dalam Kws. Konservasi)(km)')"
                    >
                      {{ errors.first("form-1.Panjang (di dalam Kws. Konservasi)(km)") }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col
                  md="6"
                  v-if="
                    dataPermohonan.jenis_pnbp == 'Kabel Bawah Laut' ||
                    dataPermohonan.jenis_pnbp == 'Pipa Air Bersih / Air Baku' ||
                    dataPermohonan.jenis_pnbp ==
                      'Pipa Selain Air Bersih / Air Baku'
                  "
                >
                  <b-form-group label="Panjang (di luar Kws. Konservasi)(km)*">
                    <b-form-input
                    disabled
                      min="0"
                      step=".01"
                      type="number"
                      name="Panjang (di luar Kws. Konservasi)(km)"
                      :class="{
                        'form-control': true,
                        'is-invalid': errors.has('form-1.Panjang (di luar Kws. Konservasi)(km)'),
                      }"
                      v-model="dataPermohonan.panjang_nonkonservasi"
                    />
                    <span
                      class="text-danger"
                      v-if="errors.has('form-1.Panjang (di luar Kws. Konservasi)(km)')"
                    >
                      {{ errors.first("form-1.Panjang (di luar Kws. Konservasi)(km)") }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Kedalaman (m) *">
                    <b-form-input
                    disabled
                      v-validate="'required'"
                      name="Kedalaman"
                      min="0"
                      step=".01"
                      :class="{
                        'form-control': true,
                        'is-invalid': errors.has('form-1.Kedalaman'),
                      }"
                      v-model="dataPermohonan.kedalaman"
                      type="number"
                    />
                    <span
                      class="text-danger"
                      v-if="errors.has('form-1.Kedalaman')"
                    >
                      {{ errors.first("form-1.Kedalaman") }}
                    </span>
                  </b-form-group>
                </b-col>

                <b-col md="12">
                    <div class="form-group mt-2">
                        <b-form-group label="Rencana Detail Kegiatan: *">
                            <ckeditor :editor="wygEditor" v-model="dataPermohonan.rencana_detail_kegiatan" disabled></ckeditor>
                        </b-form-group>
                    </div>
                </b-col>

                <b-col md="12">
                    <div class="form-group mt-2">
                        <b-form-group label="Hasil Penilaian Teknis: *">
                            <ckeditor :editor="wygEditor" v-model="dataPermohonan.hasil_verifikasi_teknis" disabled></ckeditor>
                        </b-form-group>
                    </div>
                </b-col>

                <b-col md="12">
                    <div class="form-group mt-2">
                        <b-form-group label="Catatan: *">
                            <ckeditor :editor="wygEditor" v-model="dataPermohonan.catatan_vertek" disabled></ckeditor>
                        </b-form-group>
                    </div>
                </b-col>
            </b-row>
            <div class="row justify-content-between">
                <div class="col-4">
                    <div class="text-left">
                        <b-button @click="previousDokumen()" variant="primary" ><i class="fa fa-caret-left" /> Previous</b-button>
                    </div>
                </div>
                <div class="col-4">
                    <div class="text-right">
                        <b-button @click="nextDokumen()" style="float:right" variant="primary" >Next <i class="fa fa-caret-right" /></b-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';
export default {
    data() {
        return {

        }
    },
    components: { vSelect },
    props: {
        dataPermohonan: {
            type: Array,
            default: () => {
                return [];
            },
        },
        dataKlasifikasi: {
            type: Array,
            default: () => {
                return [];
            },
        },
        dataProvinsi: {
            type: Array,
            default: () => {
                return [];
            },
        },
        dataKabupaten: {
            type: Array,
            default: () => {
                return [];
            },
        },
        dataJenisPermohonan: {
            type: Array,
            default: () => {
                return [];
            },
        },
        dataKecamatan: {
            type: Array,
            default: () => {
                return [];
            },
        },
        wygEditor: {
            type: Array,
            default: () => {
                return [];
            },
        },
    },
    methods: {
        finishDokumen() {
            this.$emit('finishDokumen')
        },

        previousDokumen(){
            this.$emit('previousDokumen')
        },

        nextDokumen(){
            this.$emit('nextDokumen')
        },

        getKabupaten(data){
            this.$emit('getKabupaten', data)
        },

        getKecamatan(data){
            this.$emit('getKecamatan', data)
        }

    }
}
</script>